"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var GraphSnapshot_1 = require("../GraphSnapshot");
var nodes_1 = require("../nodes");
var util_1 = require("../util");
var SnapshotEditor_1 = require("./SnapshotEditor");
/**
 * Returns the migrated entity snapshot. Supports add and modify but not delete
 * fields.
 */
function migrateEntity(id, snapshot, nodesToAdd, migrationMap) {
    // Only if object and if valid MigrationMap is provided
    if (!util_1.isObject(snapshot.data))
        return snapshot;
    var entityMigrations = util_1.deepGet(migrationMap, ['_entities']);
    var parameterizedMigrations = util_1.deepGet(migrationMap, ['_parameterized']);
    var typeName = snapshot.data.__typename || 'Query';
    if (entityMigrations && entityMigrations[typeName]) {
        for (var field in entityMigrations[typeName]) {
            var fieldMigration = entityMigrations[typeName][field];
            if (!fieldMigration)
                continue;
            snapshot.data[field] = fieldMigration(snapshot.data[field]);
        }
    }
    if (parameterizedMigrations && parameterizedMigrations[typeName]) {
        var _loop_1 = function (parameterized) {
            var fieldId = SnapshotEditor_1.nodeIdForParameterizedValue(id, parameterized.path, parameterized.args);
            // create a parameterized value snapshot if container doesn't know of the
            // parameterized field we expect
            if (!snapshot.outbound || !snapshot.outbound.find(function (s) { return s.id === fieldId; })) {
                var newNode = new nodes_1.ParameterizedValueSnapshot(parameterized.defaultReturn);
                nodesToAdd[fieldId] = newNode;
                // update the reference for the new node in the container
                util_1.addNodeReference('inbound', newNode, id, parameterized.path);
                util_1.addNodeReference('outbound', snapshot, fieldId, parameterized.path);
            }
        };
        try {
            for (var _a = tslib_1.__values(parameterizedMigrations[typeName]), _b = _a.next(); !_b.done; _b = _a.next()) {
                var parameterized = _b.value;
                _loop_1(parameterized);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return snapshot;
    var e_1, _c;
}
/**
 * Migrates the CacheSnapshot. This function migrates the field values
 * in place so use it with care. Do not use it on the Hermes' current
 * CacheSnapshot. Doing so run the risk of violating immutability.
 */
function migrate(cacheSnapshot, migrationMap) {
    if (migrationMap) {
        var nodesToAdd = Object.create(null);
        var nodes = cacheSnapshot.baseline._values;
        for (var nodeId in nodes) {
            var nodeSnapshot = nodes[nodeId];
            if (nodeSnapshot instanceof nodes_1.EntitySnapshot) {
                migrateEntity(nodeId, nodeSnapshot, nodesToAdd, migrationMap);
            }
        }
        // rebuild the migrated GraphSnapshot
        var snapshots = tslib_1.__assign({}, cacheSnapshot.baseline._values);
        for (var addId in nodesToAdd) {
            var nodeToAdd = nodesToAdd[addId];
            if (!nodeToAdd)
                continue;
            snapshots[addId] = nodeToAdd;
        }
        cacheSnapshot.baseline = new GraphSnapshot_1.GraphSnapshot(snapshots);
    }
    return cacheSnapshot;
}
exports.migrate = migrate;
//# sourceMappingURL=data:application/json;base64,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